import React, { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import axios from 'axios';

function EditCoef() {
    const navigate = useNavigate();
    const {profile} = useContext(AuthContext);
    const [coef, setCoef] = useState({
        minPrice: '',
        maxPrice: '',
        coefficient: null,
        username:profile.username
    })
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setCoef((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSave = () => {
        if (coef.coefficient>0) {

            axios.post('https://api.elnaf.fi/api/editCoefficient.php', JSON.stringify(coef), {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            })
                .then(response => {
                    const data = response.data;

                    if (data.status === 'success') {
                        alert('Coefficient updated successfully!');
                        navigate('/products');
                    } else {
                        alert('Error: ' + data.message);
                    }
                })
                .catch(error => {
                    console.error(error);
                });
        }
    }
    return (
        <div className="row mb-3">
            <div className="col-md-1">
                <input type="text" onChange={handleInputChange} className="form-control" name="minPrice" value={coef.minPrice} placeholder="0" />
                <label htmlFor="minPrice" className="form-label">Min Price</label>
            </div>
            <div className="col-md-1">
                <input type="text" onChange={handleInputChange} className="form-control" name="maxPrice" value={coef.maxPrice} placeholder="99999" />
                <label htmlFor="maxPrice" className="form-label">Max Price</label>
            </div>
            <div className="col-md-1">
                <input type="text" onChange={handleInputChange} className="form-control" name="coefficient" value={coef.coefficient} placeholder="1.6" />
                <label htmlFor="coefficient" className="form-label">Coefficient</label>
            </div>
            <div className="col-md-1 ">
                <div className="btn-list align-items-start h-100 d-flex">
                    <button disabled={!(coef.coefficient && (coef.maxPrice || coef.minPrice))} onClick={handleSave} className="btn btn-primary m-0" >Save</button>
                </div>
            </div>

        </div>
    )
}

export default EditCoef